export const agentPages = [
  { key: "dashboard", label: "Dashboard" },
  { key: "conversations", label: "Conversations" },
  { key: "tickets", label: "Tickets" },
  { key: "analytics", label: "Analytics and Site insights" },
];

export const canAccessPage = (user, page) => {
  if (user?.role === "admin" || user?.isSuperAdmin) return true;
  const allowed = Array.isArray(user?.permissions) ? user.permissions : agentPages.map(item => item.key);
  return allowed.includes(page);
};

export const firstAllowedPath = user => {
  const first = agentPages.find(item => canAccessPage(user, item.key));
  return first ? `/${first.key}` : "/no-access";
};
